import { useTranslation } from 'react-i18next';
import { Button, CheckBox, Popover } from '@anytag/shared-atoms';
import { useSelectItemIds } from '@anytag/shared-hooks';
import { cn } from '@anytag/shared-utils';
import { AnalyticsFacebookDashboardLegendType, AnalyticsFacebookDashboardGraphKeys as Keys } from '../types';
import { getAllLegendOptions, getDropdownLegendKeys } from '../utils';

interface Props {
  isInfluencerProfile?: boolean;
}
export const useAnalyticsFacebookDashboardOverviewLegend = ({ isInfluencerProfile }: Props) => {
  const { t } = useTranslation();
  const { setSelectedItemIds: setSelectedDropdownLegendKeys, selectedItemIds: selectedDropdownLegendKeys } =
    useSelectItemIds<Keys>();
  const {
    selectItem: setSelectingDropdownLegendKey,
    selectedItemIds: selectingDropdownLegendKeys,
    setSelectedItemIds: setSelectingDropdownLegendKeys
  } = useSelectItemIds<Keys>();

  const allLegendOptions = getAllLegendOptions(isInfluencerProfile);
  const dropdownLegendKeys = getDropdownLegendKeys(isInfluencerProfile);
  const legendOptions: AnalyticsFacebookDashboardLegendType[] = allLegendOptions.map((option) => ({
    ...option,
    label: option.label ? t<string>(option.label) : ''
  }));
  const availableLegendOptions = legendOptions.filter(
    ({ value }) => !dropdownLegendKeys.includes(value) || selectedDropdownLegendKeys.includes(value)
  );

  return {
    availableLegendOptions,
    ButtonSelectMoreLegendOptions: (
      <Popover
        onClose={() => setSelectingDropdownLegendKeys(selectedDropdownLegendKeys)}
        side="bottom"
        align="end"
        target={({ togglePopover }) => (
          <Button variant="outline" onClick={togglePopover} prefixIcon={{ icon: 'plus', size: 12 }} />
        )}
        targetProps={{
          className: cn('bg-light-gray', isInfluencerProfile ? 'ml-3' : 'ml-auto')
        }}
      >
        {({ togglePopover }) => (
          <div className="w-62">
            <div className="p-2">
              {dropdownLegendKeys.map((key) => (
                <CheckBox
                  key={key}
                  className="not-first-of-type:mt-4"
                  onClick={() => setSelectingDropdownLegendKey(key)}
                  checked={selectingDropdownLegendKeys.includes(key)}
                  label={legendOptions.find((item) => item.value === key)?.label}
                />
              ))}
            </div>
            <div className="border-t-border p-2">
              <Button
                variant="solid"
                title={t('Button.Save')}
                css={{ minWidth: '66px', height: '24px', marginLeft: 'auto', textTransform: 'uppercase' }}
                onClick={() => {
                  setSelectedDropdownLegendKeys(selectingDropdownLegendKeys);
                  togglePopover();
                }}
              />
            </div>
          </div>
        )}
      </Popover>
    )
  };
};
